module.exports = __webpack_public_path__ + "img/weibo_code1.ce4e4ae6.png";